import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        @media (max-width: 1700px){
            font-size: 70%;
        }

    }

    body {
        background: linear-gradient(135deg, #0f0a1a 0%, #1a1025 50%, #0d0d15 100%);
        font-family: 'Inter', sans-serif;
        overflow-x: hidden;
        min-height: 100vh;
    }

    button {
        font-weight: bold;
        font-size: 1.1.rem;
        cursor: pointer;
        padding: 1rem 2rem;
        border: 3px solid #9b59b6;
        background: transparent;
        color: white;
        transition: all 0.5s ease;
        font-family: 'Inter', sans-serif;

        &:hover {
            background: linear-gradient(135deg, #9b59b6 0%, #e74c3c 100%);
            color: white;
            border-color: #9b59b6;
        }
    }
    h2 {
            font-weight: lighter;
            font-size: 4rem;
        }

    h3 {
        color: white;
    }

    h4 {
        font-weight: bold;
        font-size: 2rem;
    }

    a {
        font-size: 1.1.rem;
    }

    span {
        color: #9b59b6;
        font-weight: bold;
    }

    p {
        padding: 3rem 0rem;
        color: #ccc;
        font-size: 1.4rem;
        line-height: 150%normal;
    }

`;

export default GlobalStyle;